module.exports = __webpack_public_path__ + "img/check-list-inactive.e25a7bc6.svg";